export const copyToClipboard = note => {
	const ta = document.createElement("textarea");
	ta.innerText = note;
	document.body.appendChild(ta);
	ta.select();
	document.execCommand("copy");
	ta.remove();
};
